/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementCreateNewsResponse } from './NewsManagementCreateNewsResponse';

export type NewsManagementCreateNewsResponseApiRespoonse = {
    data?: NewsManagementCreateNewsResponse;
    status?: NewsManagementCreateNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementCreateNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

